import { isBefore, isValid, milliseconds, setMilliseconds, sub } from "date-fns";
var time_range_DURATION_UNIT = /*#__PURE__*/ function(DURATION_UNIT) {
    DURATION_UNIT["MILLISECOND"] = "ms";
    DURATION_UNIT["SECOND"] = "s";
    DURATION_UNIT["MINUTE"] = "m";
    DURATION_UNIT["HOUR"] = "h";
    DURATION_UNIT["DAY"] = "d";
    DURATION_UNIT["WEEK"] = "w";
    DURATION_UNIT["MONTH"] = "M";
    DURATION_UNIT["YEAR"] = "y";
    return DURATION_UNIT;
}({});
const DURATION_REGEX = new RegExp("^(?:(\\d+)y)?(?:(\\d+)M)?(?:(\\d+)w)?(?:(\\d+)d)?(?:(\\d+)h)?(?:(\\d+)m)?(?:(\\d+)s)?(?:(\\d+)ms)?$");
function isDurationString(maybeDuration) {
    const trimmed = maybeDuration.trim();
    if ('' === trimmed) return false;
    return DURATION_REGEX.test(trimmed);
}
function parseDurationString(durationString) {
    const matches = DURATION_REGEX.exec(String(durationString).trim());
    if (null === matches) throw new Error(`Invalid duration string '${durationString}'`);
    return {
        years: parseInt(matches[1] ?? '0'),
        months: parseInt(matches[2] ?? '0'),
        weeks: parseInt(matches[3] ?? '0'),
        days: parseInt(matches[4] ?? '0'),
        hours: parseInt(matches[5] ?? '0'),
        minutes: parseInt(matches[6] ?? '0'),
        seconds: parseInt(matches[7] ?? '0') + parseInt(matches[8] ?? '0') / 1000
    };
}
function getDurationStringMilliseconds(durationString) {
    if (void 0 === durationString || '' === durationString) return;
    const duration = parseDurationString(durationString);
    return milliseconds(duration);
}
function getDurationStringSeconds(durationString) {
    const durationMs = getDurationStringMilliseconds(durationString);
    if ('number' != typeof durationMs) return;
    return Math.floor(durationMs / 1000);
}
function getDurationString(duration) {
    const result = `${duration.years ? `${duration.years}y` : ''}${duration.months ? `${duration.months}M` : ''}${duration.weeks ? `${duration.weeks}w` : ''}${duration.days ? `${duration.days}d` : ''}${duration.hours ? `${duration.hours}h` : ''}${duration.minutes ? `${duration.minutes}m` : ''}${duration.seconds ? `${duration.seconds}s` : ''}`;
    if ('' === result) return;
    return result;
}
function isRelativeTimeRange(timeRange) {
    return void 0 !== timeRange.pastDuration;
}
function isAbsoluteTimeRange(timeRange) {
    return void 0 !== timeRange.start && void 0 !== timeRange.end;
}
function toAbsoluteTimeRange(timeRange) {
    const end = timeRange.end ?? setMilliseconds(new Date(), 0);
    return {
        start: sub(end, parseDurationString(timeRange.pastDuration)),
        end
    };
}
function areTimeRangesEqual(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (isRelativeTimeRange(a) && isRelativeTimeRange(b)) return a.pastDuration === b.pastDuration && a.end?.getTime() === b.end?.getTime();
    if (isAbsoluteTimeRange(a) && isAbsoluteTimeRange(b)) {
        const startA = a.start instanceof Date ? a.start : new Date(a.start);
        const endA = a.end instanceof Date ? a.end : new Date(a.end);
        const startB = b.start instanceof Date ? b.start : new Date(b.start);
        const endB = b.end instanceof Date ? b.end : new Date(b.end);
        return startA.getTime() === startB.getTime() && endA.getTime() === endB.getTime();
    }
    return false;
}
const TIME_RANGE_INVALID_ORDER_MESSAGE = 'Range is not valid. Start date and time is after end date and time.';
function isValidTimeRange({ start, end, isEndOptional }) {
    const isStartValid = null !== start && isValid(start);
    const isEndValid = null !== end && isValid(end);
    if (isEndOptional) return isStartValid;
    return isStartValid && isEndValid && isBefore(start, end);
}
function combineDateAndTime(dateWithDate, dateWithTime) {
    const modifiedDate = new Date(dateWithDate.getTime());
    modifiedDate.setHours(dateWithTime.getHours(), dateWithTime.getMinutes(), dateWithTime.getSeconds(), dateWithTime.getMilliseconds());
    return modifiedDate;
}
export { time_range_DURATION_UNIT as DURATION_UNIT, TIME_RANGE_INVALID_ORDER_MESSAGE, areTimeRangesEqual, combineDateAndTime, getDurationString, getDurationStringMilliseconds, getDurationStringSeconds, isAbsoluteTimeRange, isDurationString, isRelativeTimeRange, isValidTimeRange, parseDurationString, toAbsoluteTimeRange };

//# sourceMappingURL=time-range.js.map